/* eslint-disable react/no-unescaped-entities */
import React from 'react';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';

const mock = [
  {   
    description:
      'Math Workshop 2025',
    href : '/math-workshop-2025'
 
  },
   {   
    description:
      'The Art of Story Telling ',
    href : '/art-of-story-telling'
 
  },
   {   
    description:
      'International Yoga Day ',
    href : '/international-yoga-day-2025'
 
  },
   {   
    description:
      'Investiture 2025 ',
    href : '/investiture-2025'
 
  },
    {   
    description:
      'Orientation 2025 ',
    href : '/orientation2025'
 
  },
{   
    description:
      'Behaviour Management ',
    href : '/behaviour-management-2025'
 
  },
  {   
    description:
      'AI in Classrooms ',
    href : '/ai-in-classrooms-2025'
 
  },
  {   
    description:
      'Sansad ',
    href : '/sansad-2025'
 
  },
  {   
    description:
      'Elevate-Inter School Sports Meet  ',
    href : '/elevate-inter-school-sports-meet'
 
  },
  {   
    description:
      'Teachers Day ',
    href : '/teachers-day-celebration-2025'
 
  },
   {   
    description:
      'Goonj Event 2025-26 ',
    href : '/goonj-2025'
 
  },
  {   
    description:
      'National Sports Day',
    href : '/national-sports-day-2025'
 
  },
  {   
    description:
      'Scintilla of Art',
    href : '/scintilla-of-art-2025'
 
  },
   {   
    description:
      'Dussehra Celebrations',
    href : '/dussehra-celebrations-2025'
 
  },
  {   
    description:
      'Fun Filled Science Session',
    href : '/science-session-2025'
  },
  {   
    description:
      'Hindi Diwas',
    href : '/hindi-diwas-2025'
  },
   {   
    description:
      'Science Exhibition',
    href : '/science-exhibition-2025'
  },
   {   
    description:
      'Bagless Day',
    href : '/bagless-day-2025'
  },
   {   
    description:
      'Solar Panel',
    href : '/solar-panel-2025'
  },
   {   
    description:
      'Kannada Rajyotsava',
    href : '/kannada-rajyotsava-2025'
  },
  {   
    description:
      'E-Waste Management',
    href : '/e-waste-management-awareness-2025'
  },
   {   
    description:
      'Children’s Day',
    href : '/childrens-day-celebrations-2025'
  },
   {   
    description:
      'SHIKAR',
    href : '/shikar-2025'
  },
   {   
    description:
      'Digital Detoxification',
    href : '/digital-detoxification-2025'
  },
  {   
    description:
      'Gita Dhara - Class 2',
    href : '/gita-dhara-class-2-2025'
  },
   {   
    description:
      'Gita Dhara - Class 3',
    href : '/gita-dhara-class-3-2025'
  },
   {   
    description:
      'Gita Dhara - Classes 3-5',
    href : '/gita-dhara-class-3to5-2025'
  },
   {   
    description:
      'Gita Dhara - Class 6',
    href : '/gita-dhara-class-6-2025'
  },
   {   
    description:
      'Christmas Celebration',
    href : '/christmas-celebration-2025'
  },
   {   
    description:
      'Geeta Dhara - Class 7',
    href : '/geeta-dhara-class-7-2025'
  },
   {   
    description:
      'Geeta Dhara - Class 8',
    href : '/geeta-dhara-class-8-2025'
  },
   {   
    description:
      'Valedictory Ceremony 2025',
    href : '/valedictory-ceremony-2025'
  },
  {
    description:
      'Graduation Day 2025',
    href : '/graduation-day-2025'
  },
  {
    description:
      'Math Fair 2025',
    href : '/math-fair-2025'
  },
  {
    description:
      'Republic Day 2025',
    href : '/republic-day-2025'
  },
  {
    description:
      'Authors Talk 2025',
    href : '/authors-talk-2025'
  },
  {
    description:
      'Health and Nutrition 2025',
    href : '/health-and-nutrition-class7-2025'
  },
  {
    description:
      'Health and Nutrition Class 3 & 4 2025',
    href : '/nutrition-session-2025'
  }
];

const Sidebar2025 = () => {
  
  return (
    <Box component={Card} variant={'outlined'} padding={2}>
      
      <Typography
        variant="h6"
        data-aos={'fade-up'}
        sx={{
          fontWeight: 700,
          marginBottom: 2,
        }}
      >
        School Programs 2025-26
      </Typography>
      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid key={i} item xs={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              borderRadius={0}
              display={'flex'}
              flexDirection={{ xs: 'column', md: 'row' }}
              sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}
            >
              <Button href = {item.href}>
                <Typography component={'P'}>
                  {item.description}
                </Typography>
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Sidebar2025;
